/**
 * Whether a classified document applies to a given project entity.
 * Empty/null tags = site-wide (all entities).
 */
export function docAppliesToEntity(doc, entityId) {
  if (!entityId) return true;
  const tags = doc?.projectBuildingDataIds;
  if (!tags?.length) return true;
  return tags.includes(entityId);
}

/** Human label for tag picker — empty selection = site-wide. */
export function formatAppliesToLabel(entityIds, entities) {
  if (!entityIds?.length) return 'All buildings (site-wide)';
  const names = entityIds
    .map((id) => entities.find((e) => e.id === id)?.name || id)
    .filter(Boolean);
  return names.length ? names.join(', ') : 'All buildings (site-wide)';
}
